export const getSelectedIds = (values) => {
  const arr = [];

  if (values.payment) {
    arr.push(parseInt(values.payment, 10));
  }

  if (values.gallery) {
    arr.push(parseInt(values.gallery, 10));
  }

  if (values.en) {
    arr.push(6);
  }

  if (values.de) {
    arr.push(7);
  }

  return arr;
};

export const newGetTotalPrice = (values, options) => {
  const arr = getSelectedIds(values);

  return arr.reduce((acc, cur) => {
    const { price, discount } = options.find(({ id }) => id === cur) || {};
    return acc + price + ((discount && discount.price) || 0);
  }, 0);
};
